<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
                <div class="panel-sub-heading headingSmall"><span
                        class="markedBottom">{{ lang('gdpr') }}</span>
                </div>
            </div>
<!--            <div class="col-lg-12 col-md-12 col-12" v-if="isOpenApplication">-->
<!--                <np-checkbox ref="gdpr_agreement"-->
<!--                             :id="'gdpr_agreement'"-->
<!--                             :name="'gdpr_agreement'"-->
<!--                             :description="lang('consent_to_gdpr')"-->
<!--                             :required="true"-->
<!--                             :value="'1'"-->
<!--                             :no-wrapper="true"-->
<!--                             v-model="quote.gdpr_agreement">-->
<!--                            <span slot="addendum">-->
<!--                                <span>-->
<!--                                    <span><a @click="mailEUDataProtectionOffice"-->
<!--                                             href="mailto:EUDataProtectionOffice@elavon.com">-->
<!--                                        EUDataProtectionOffice@elavon.com.</a></span>-->
<!--                                    <span class="pl-2" @click="setModalData" style="cursor: pointer;">{{lang('view_privacy_policy')}}</span>-->
<!--                                </span>-->
<!--                            </span>-->
<!--                </np-checkbox>-->
<!--            </div>-->
<!--            <div class="col-lg-12 col-md-12 col-12" v-else>-->
            <div class="col-lg-12 col-md-12 col-12">
                <span slot="addendum">
                    <span>
                        <span>
                            {{lang('consent_to_gdpr')}}
                            <a @click="mailEUDataProtectionOffice" href="mailto:EUDataProtectionOffice@elavon.com">
                            EUDataProtectionOffice@elavon.com.</a></span>
<!--                        <span class="pl-2" @click="setModalData" style="cursor: pointer;">{{lang('view_privacy_policy')}}</span>-->
                        {{lang('view')}}
                        <span><a style="display: inline; cursor: pointer;" target="_blank" :href="privacy_policy_link">{{lang('privacy_policy')}}</a>.</span>
                    </span>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12" v-if="isOpenApplication && (show_marketing_opt_in || show_marketing_opt_out)">
<!--                <np-radios-->
<!--                        :label="lang('marketing_opt_in')"-->
<!--                        :id="'marketing_opt_in'"-->
<!--                        :name="'marketing_opt_in'"-->
<!--                        ref="marketing_opt_in"-->
<!--                        :check_config="false"-->
<!--                        :required="true"-->
<!--                        mode="co-join"-->
<!--                        :options="parameters.YES_NO_OPTIONS"-->
<!--                        v-model="quote.marketing_opt_in">-->
<!--                    <div slot="addendum">-->
<!--                        <label id="marketing-help" v-html="lang('marketing_opt_in_tooltip')"></label>-->
<!--                    </div>-->
<!--                </np-radios>-->
                <div class="row">
                    <div class="col-12">
                        <div class="panel-sub-heading headingSmall"><span
                                class="markedBottom">{{ lang('give_info') }}</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <np-checkbox
                                v-if="show_marketing_opt_in"
                                :label="lang('marketing_opt_in')"
                                :id="'marketing_opt_in_consent'"
                                :name="'marketing_opt_in_consent'"
                                :description="lang('marketing_opt_in_tooltip')"
                                :full-label="true"
                                :check_config="true"
                                v-model="quote.marketing_opt_in">
                        </np-checkbox>
                    </div>
                    <div class="col-12">
                        <np-checkbox
                                v-if="show_marketing_opt_out"
                                :label="lang('marketing_opt_out')"
                                :id="'marketing_opt_out_consent'"
                                :name="'marketing_opt_out_consent'"
                                :description="lang('marketing_opt_out_tooltip')"
                                :full-label="true"
                                :invert-check="true"
                                :check_config="true"
                                v-model="quote.marketing_opt_in">
                        </np-checkbox>
                    </div>
                </div>
            </div>
<!--            <div class="col-6 pt-3" v-else>-->
<!--                <np-entry-->
<!--                        :label="lang('marketing_opt_in')"-->
<!--                        mode="inline"-->
<!--                        :value="quote.marketing_opt_in"-->
<!--                        :formatter="formatBooleanOption">-->
<!--                </np-entry>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>

    import applicationMixin from "../../../utils/application-mixin";
    import {mapState} from 'pinia';
    import {NPCheckBox, NPNotice, NPPdfModal, NPRadios} from "netpify/components";
    import utilMixin from "../../../utils/mixins";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "Gdpr-Block",
        mixins: [applicationMixin, utilMixin],
        components: {
            'np-radios': NPRadios,
            'np-notice': NPNotice,
            'np-checkbox': NPCheckBox,
            'np-pdf-modal': NPPdfModal
        },
        metaInfo() {
            return {
                title: this.lang('tab_review')
            }
        },
        beforeRouteEnter(to, from, next) {

            next(vm => {

                // vm.setAppPageTitle(vm.page_label);
                // vm.openFirstSection()
            })
        },
        props: {
            show_gdpr_block: {
                type: Boolean,
                default: () => {
                    return false;
                }
            },
        },
        data: function () {
            return {
                // show_gdpr_block: true,
                privacy_policy_link: '',
            };
        },
        created() {
            this.privacy_policy_link = vue_data.hasOwnProperty('parameters') && vue_data.parameters.hasOwnProperty('BRANDING') ? vue_data.parameters.BRANDING.privacy_policy_link : 'https://www.elavon.co.uk/privacy-policy.html';
        },
        methods: {
            setModalData: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $('#elavon-gdpr-pdf').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            mailEUDataProtectionOffice: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                window.location.href = "mailto:EUDataProtectionOffice@elavon.com";
                objCommon.generalPreloader.hide_pl();
            },
            //Moved to mixin
            // checkConfig: function(check_type=null, config=null, template_name=null, block_name=null, element_name=null){
            //     console.log('Independent checkConfig')
            //     let checks = ['IS_REQUIRED', 'IS_SELECTED']
            //
            //     const check = (attribute) => {
            //         if(check_type === 'IS_REQUIRED')
            //         {
            //             return attribute.is_required === 'Y'
            //         }
            //         else if(check_type === 'IS_SELECTED'){
            //             return attribute.selected === 'Y'
            //         }
            //         return false
            //     }
            //
            //     if(check_type && checks.find(e => e === check_type)) {
            //         let template = config && template_name ? config[template_name] : null
            //         let blocks = template && template.hasOwnProperty('blocks') ? template['blocks'] : null
            //         let block = blocks && blocks.hasOwnProperty(block_name) ? blocks[block_name] : null
            //         let elements = block && block.hasOwnProperty('elements') ? block['elements'] : null
            //         let element = elements && element_name ? elements[element_name] : null
            //
            //         if (element && element.hasOwnProperty('attribute')) {
            //             return check(element.attribute)
            //         } else if (block && element.hasOwnProperty('attribute')) {
            //             return check(block.attribute)
            //         }
            //     }
            //
            //     return false
            //
            // }
        },
        computed: {
            ...mapState(useApplicationStore,{ app_chain: 'application' }),
            show_marketing_opt_in: function(){
                //check page config
                let template_name = 'SelfBusinessCriteria';
                let config = this.page_config && this.page_config.hasOwnProperty(template_name) ? this.page_config[template_name] : null
                let block = 'block_application_options'
                let element = 'marketing_opt_in'

                if(config)
                {
                    let response = this.checkConfig('IS_SELECTED', this.page_config, template_name, block, element)
                    // console.log('Check selected ', element, response)
                    return response
                }
                return false
            },
            show_marketing_opt_out: function(){
                //check page config
                let template_name = 'SelfBusinessCriteria';
                let config = this.page_config && this.page_config.hasOwnProperty(template_name) ? this.page_config[template_name] : null
                let block = 'block_application_options'
                let element = 'marketing_opt_out'

                if(config)
                {
                    let response = this.checkConfig('IS_SELECTED', this.page_config, template_name, block, element)
                    // console.log('Check selected ', element, response)
                    return response
                }
                return false
            }
        },
        watch: {
            // 'app_chain.merchant.merchant_control': {
            //     immediate: true,
            //     handler: function (val) {
            //         let vm = this;
            //         if (val === '1') {
            //             vm.show_gdpr_block = false;
            //         }
            //         else {
            //             vm.show_gdpr_block = true;
            //         }
            //     }
            // },
        }
    }
</script>
